/* eslint-disable  import/no-default-export */

import template from './agent-bonus.jade';
import validation from './../../../services/validation';

const bonusTypes = [
  { value: null, name: 'Нет' },
  { value: 'fixed', name: 'Фиксированная сумма' },
  { value: 'percent', name: 'Процент от сделки' },
];

export default angular.module('cian.addForm.agentBonus', []).directive('cianAfPriceAndDealTermsAgentBonus', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'deviceService',
    function ($scope, deviceService) {
      this.isMobile = deviceService.isMobile;

      this.bonusTypes = bonusTypes;

      if (!this.ad.bargainTerms) {
        this.ad.bargainTerms = {};
      }
      if (!this.ad.bargainTerms.agentBonus) {
        this.ad.bargainTerms.agentBonus = {};
      }

      if (!this.ad.bargainTerms.agentBonus.paymentType) {
        this.ad.bargainTerms.agentBonus.paymentType = bonusTypes[0].value;
        this.ad.bargainTerms.agentBonus.value = null;
      }

      if (this.ad.bargainTerms.agentFee != null) {
        delete this.ad.bargainTerms.agentFee;
      }

      if (this.ad.bargainTerms.clientFee != null) {
        delete this.ad.bargainTerms.clientFee;
      }

      this.typeChanged = type => {
        this.ad.bargainTerms.agentBonus.value = null;
        this.ad.bargainTerms.agentBonus.paymentType = type;
        setCurrencyWatcher();
      };

      let removeCurrencyWatch;

      // Следим за валютой сделки при фиксированной сумме
      const setCurrencyWatcher = () => {
        if (this.ad.bargainTerms.agentBonus.paymentType === 'fixed') {
          removeCurrencyWatch = $scope.$watch(
            () => this.ad.bargainTerms.currency,
            (priceCurrency, oldVal) => {
              if (priceCurrency !== oldVal) {
                this.ad.bargainTerms.agentBonus.currency = priceCurrency;
              }
            },
          );
        } else {
          if (removeCurrencyWatch) {
            removeCurrencyWatch();
          }
          this.ad.bargainTerms.agentBonus.currency = undefined;
        }
      };

      this.fixedValidationMessages = {
        required: 'Укажите сумму бонуса',
        min: 'Сумма не может быть отрицательной',
      };

      this.percentValidation = validation(this.form, 'bargainTerms.agentBonus.value', {
        required: 'Укажите процент от сделки',
        max: 'Процент не может быть более 100%',
        min: 'Процент не может быть отрицательным',
        parse: 'Указывать можно только числа',
      });

      setCurrencyWatcher();
    },
  ],
  controllerAs: 'c',
  template,
})).name;
